import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl font-bold mb-6">About Luxe-Looks</h2>
          <p className="text-gray-600 mb-4">
            Welcome to Luxe-Looks, your premier destination for luxury beauty and cosmetics. 
            We believe everyone deserves to feel confident and beautiful in their own skin.
          </p>
          <p className="text-gray-600 mb-6">
            Our curated collection features the world's most prestigious beauty brands, from classic 
            favorites to cutting-edge innovators. Whether you're seeking premium skincare, 
            vibrant makeup, or luxurious fragrances, we bring you the very best in beauty.
          </p>
          <p className="text-gray-600">
            With fast delivery, authentic products, and exceptional customer service, 
            Luxe-Looks is more than a shopping destination—it's your partner in beauty.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;